import { render, staticRenderFns } from "./EsamiLaboratorioEditComponent.vue?vue&type=template&id=464132f4&scoped=true"
import script from "./EsamiLaboratorioEditComponent.vue?vue&type=script&lang=js"
export * from "./EsamiLaboratorioEditComponent.vue?vue&type=script&lang=js"
import style0 from "./EsamiLaboratorioEditComponent.vue?vue&type=style&index=0&id=464132f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464132f4",
  null
  
)

export default component.exports